import { useTranslation } from 'react-i18next';
import {
  Box,
  Center,
  Text,
  Image,
  Stack,
  useBreakpointValue
} from '@chakra-ui/react';


export default function Footer() {
  const mainColor = "#045846";
  const secColor = "#ed2224";
  
  const { t } = useTranslation();

  const patternHeight = useBreakpointValue({ base: "80px", md: "100px" });

  return (
    <Box position="relative" bg={mainColor} color={'#fff'}  pb={patternHeight} overflow="hidden">
      {/* Footer Content */}
      <Stack spacing={2} align="center" textAlign="center">
        <Text fontSize={{ base: "sm", md: "md" }}  letterSpacing="wide">
          {t('footer.rights')}
        </Text>
      </Stack>
    </Box>
  );
}
